<template>
  <div>
    <div :class="getTopPurpleBar()"></div>
    <!-- <div class="white-behind" v-show="!newVersion()">
      <div class="top-purple" :style="{ backgroundImage: 'url(' + getBackgroundPattern() + ')' }">
        <img :src="topPattern" class="img-fluid bg-logo" :alt="LG('HP_altLogo')">
      </div>
      <div class="middle-white"></div>
    </div> -->
    <div class="confetti-backdrop" :style="{ backgroundImage: 'url(' + getConfettiPattern() + ')' }">
      <div class="center-background-area">
        <Login @mute-clicked="onMuteClicked()"></Login>
        <!-- <img v-show="!newVersion()" :src="logo" class="img-fluid bg-logo" :alt="LG('HP_altLogo')" />

        <div v-show="!newVersion()">
          <div class="kids-playing">
            <img :src="children" class="img-fluid" alt="" />
          </div>
        </div> -->

        <div :class="getHomePageCenterAreaClass()">
          <div :class="getMainTextClass()">
            <div v-show="newVersion()">
              <br aria-hidden="true" />
            </div>
            <br aria-hidden="true" />
            <!--<h2 v-show="newVersion()" class="main-heading centered-element" v-html="LG('HP_titleIntroduction')"></h2>-->
            <br aria-hidden="true" />
            <p id="id-paragraph1" v-html="LG('HP_paragraph1')"></p>
            <p id="id-paragraph2" v-html="LG('HP_paragraph2')"></p>
            <!--<p id="id-paragraph2" v-html="LG('HP_paragraph3')"></p>-->
            <br aria-hidden="true" />
            <b-button class="centered-element funky-shape" v-show="!isStartButtonDisabled()" v-on:click="onStartGameButtonClicked()">{{ LG("G_startButtonLabel") }}</b-button>

            <div v-if="$store.state.userlist.length > 0" class="admin-section">
              <h2>ADMIN</h2>
              <br aria-hidden="true" />
              <div v-show="!userIsSelected">
                <div v-for="user in $store.state.userlist" :key="user.email">
                  <div class="row">
                    <button v-on:click="onAdminSelectUser(user)">{{ displayUserInfo(user) }}</button>
                  </div>
                  <br aria-hidden="true" />
                </div>
              </div>
              <div v-show="userIsSelected">
                <p>{{ displayUserName() }}</p>
                <p>{{ displayUserEmail() }}</p>
                <button v-on:click="onAdminDeleteSelectedUser()">{{ LG("G_DeleteButton") }}</button>
                <br aria-hidden="true" /><br aria-hidden="true" />
                <button v-on:click="onAdminCancelSelectedUser()">{{ LG("G_CancelLabel") }}</button>
              </div>
            </div>
          </div>
          <div class="col-sm-7 video-area">
            <br aria-hidden="true" />
            <div v-show="newVersion()">
              <br aria-hidden="true" />
            </div>

            <VideoPlayer :mediaId="mediaId" ref="videoIntroRef" youtube="no" @video-ended="onVideoEnded()" :transcription="getVideoTranscription()"></VideoPlayer>
          </div>
          <div v-show="newVersion()">
            <img :src="childrenNew" class="img-fluid children-banner-new" alt="" v-show="$store.state.userlist.length == 0" />

            <div role="contentinfo" class="white-footer">
              <img :src="logoACUFC" class="logo-acufc img-fluid" alt="" />
              <img :src="logoCanada" class="logo-canada img-fluid" :alt="LG('HP_altCanadaLogo')" />
            </div>
          </div>
        </div>
        <!-- <div role="contentinfo" v-show="!newVersion()">
          <img :src="logoDark" class="img-fluid logo-bottom" :alt="LG('HP_altLogo')" />
        </div> -->
      </div>
    </div>
    <AudioPlayer id="id-introaudio" :url="introAudio" registered="yes" autoplay="yes"></AudioPlayer>
    <AudioPlayer id="id-continue-audio" ref="continueAudioRef" :url="continueAudio" autoplay="no"></AudioPlayer>
  </div>
</template>

<script>
import Login from "../components/Login.vue";
import VideoPlayer from "../components/VideoPlayer.vue";
import AudioPlayer from "../components/AudioPlayer.vue";

export default {
  components: {
    Login,
    VideoPlayer,
    AudioPlayer,
  },
  data() {
    return {
      // Images
      logo: require("@/assets/menus/main/logo.png"),
      logoDark: require("@/assets/menus/main/logo-gray.png"),
      logoACUFC: require("@/assets/menus/main/ACUFC.png"),
      logoCanada: require("@/assets/menus/main/Canada.jpg"),
      topPattern: require("@/assets/menus/main/background_top_overlay.png"),
      confetti: require("@/assets/menus/main/bg-repeat.png"),
      children: require("@/assets/menus/main/children.png"),
      childrenNew: require("@/assets/menus/main/childs.png"),

      // Audio
      introAudio: "/audio/partager/partager_introduction.mp3",
      continueAudio: "/audio/partager/partager_clique_commencer.mp3",

      // Video
      videoUrl: "https://cdn.jwplayer.com/videos/EDrL0MQp-O8RTBfsm.mp4",
      videoPoster: "https://cdn.jwplayer.com/thumbs/EDrL0MQp-1280.jpg",
      mediaId: "EDrL0MQp",

      // Variables
      adminUserSelected: null,
      userIsSelected: false,
      introVideoTranscription: "/videos/intro.txt",
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.adminUserSelected = null;
    this.userIsSelected = false;
    // TBD - this is to test admin
    //this.$store.commit("createFakeUserList");
  },
  methods: {
    onMuteClicked() {
      if (this.$refs.videoIntroRef != null) {
        // Mute the youtube video when mute button clicked (other type of video is automatic)
        if (this.$store.state.gamestate.muted) {
          this.$refs.videoIntroRef.setMute(true);
        } else {
          this.$refs.videoIntroRef.setMute(false);

          // When unmututing the audio, if the video is playing, pause the startup audio
          if (this.$refs.videoIntroRef.isPlaying) {
            this.pauseAllAudio();
          }
        }
      }
    },
    getVideoTranscription() {
      return this.introVideoTranscription;
    },
    getVideoWidth() {
      if (this.newVersion()) {
        return "95%";
      }
      return "420";
    },
    getVideoHeight() {
      if (this.newVersion()) {
        return "300";
      }
      return "240";
    },
    getTopPurpleBar() {
      if (this.newVersion()) {
        return "purple-top-bar-bg-new purple-top-bar-bg-bigger";
      }
      return "purple-top-bar-bg";
    },
    getHomePageCenterAreaClass() {
      if (this.newVersion()) {
        return "row main-content-area-new";
      } else {
        return "row main-content-area";
      }
    },
    getMainTextClass() {
      if (this.newVersion()) {
        return "col-sm-5 main-text-new";
      }
      return "col-sm-5 main-text";
    },
    displayUserInfo(user) {
      var info = user.firstName + " " + user.lastName + " : " + user.email;
      return info;
    },
    displayUserName() {
      if (this.adminUserSelected == null || this.adminUserSelected.firstName == null) {
        return "";
      }
      return this.adminUserSelected.firstName + " " + this.adminUserSelected.lastName;
    },
    displayUserEmail() {
      if (this.adminUserSelected == null || this.adminUserSelected.email == null) {
        return "";
      }
      return this.adminUserSelected.email;
    },
    onAdminSelectUser(user) {
      this.adminUserSelected = user;
      this.userIsSelected = true;
    },
    onAdminDeleteSelectedUser() {
      if (this.adminUserSelected == null || this.adminUserSelected.email == null) {
        alert("Invalid selected user has no email, delete failed");
        return;
      }
      // This deletes user from the DB
      this.deleteUserBackend(this.adminUserSelected);

      // This removes from list to see immediate update
      this.$store.commit("deleteUser", this.adminUserSelected.email);

      // Resets some variables
      this.onAdminCancelSelectedUser();
    },
    onAdminCancelSelectedUser() {
      this.adminUserSelected = null;
      this.userIsSelected = false;
    },
    isStartButtonDisabled() {
      //console.log("Store says: WATCHED VIDEO = " + this.$store.state.gamestate.watchedVideo);
      // Disable the start button until the user has watched the intro video at least once
      if (this.$store.state.gamestate.watchedVideo == true) {
        return false;
      }
      return true;
    },
    onVideoEnded() {
      this.$store.commit("setWatchedVideo", true);
      this.saveGameState();
      this.pauseAllAudio();
      this.$refs.continueAudioRef.playAudio();
    },
    onStartGameButtonClicked() {
      // When user presses start game, if not logged in at all, login as guest
      if (this.$store.state.loggedin == false) {
        console.log("Logging in as guest...");
      }

      this.$store.commit("setReturnpage", "");
      this.$router.push("/environment");
    },
    getBackgroundPattern() {
      if (this.newVersion()) {
        return "";
      }
      // This is for old layout
      return this.topPattern;
    },
    getConfettiPattern() {
      if (!this.newVersion()) {
        return "";
      }
      // this is for new layout
      return this.confetti;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.confetti-backdrop {
  min-width: 1000px;
  min-height: 500px;
  height: 100%;
  width: 100%;
}

.white-behind {
  background-color: #f8f8f8 !important;
  height: 400px;
}

.top-purple {
  width: 100%;
  height: 180px;
  clip-path: polygon(0% 0%, 100% 0%, 100% 60%, 0% 100%);
  /*background-color: #5E4064 !important;*/
  background-color: #07415b !important;
  color: white;
}

.middle-white {
  width: 100%;
  height: 520px;
  /*clip-path: polygon(0% 0%, 100% 0%, 100% 80%, 0% 100%);*/
  clip-path: polygon(0% 0%, 100% 0%, 100% 55%, 0% 100%);
  background-color: white;
  color: black;
}

.center-background-area {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 0%;
  height: 100%;
  max-width: 1000px;
  background-color: transparent;
}

.bg-logo {
  position: absolute;
  top: 48px;
  left: 0px;
}

.main-text {
  font-family: "Poppins";
  font-size: 17px;
  padding: 10px;
}

.main-text-new {
  font-family: "Poppins";
  font-size: 17px !important;
  padding: 2px;
  color: black;
}

.main-content-area {
  position: absolute;
  top: 200px;
  left: 0px;
  padding-left: 20px;
}

.main-content-area-new {
  position: absolute;
  top: 200px;
  left: 0px;
  padding-left: 35px;
  border-radius: 50px;
  border: 10px solid #ffffff;
  max-width: 1300px !important;
  min-height: 525px;
  font-size: 22px;
  background-color: #f3f3f3;
}

.main-heading {
  font-family: "Poppins";
  font-size: 22px !important;
}

.kids-playing {
  position: absolute;
  top: 475px;
  left: 350px;
  width: 900px;
}

.children-banner-new {
  position: absolute;
  top: 88%;
  left: 10%;
  width: 75%;
}

.white-footer {
  width: 100%;
  background-color: white !important;
  position: absolute;
  top: 120%;
  left: 0px;
  height: 110px;
}

.logo-acufc {
  background-color: white !important;
  height: 100%;
  width: auto;
  position: relative;
  top: 0px;
  left: 0px;
  z-index: 2;
}

.logo-canada {
  background-color: white !important;
  height: 100%;
  width: auto;
  position: relative;
  top: 0px;
  left: 0px;
  z-index: 2;
}

.logo-bottom {
  position: relative;
  top: 92%;
  left: 40%;
}

.video-area {
  display: block;
  margin-left: auto;
  margin-right: auto;
  min-height: 200px;
}

.purple-top-bar-bg {
  background-color: #052433;
  width: 100%;
  height: 40px;
  z-index: 2;
}

.purple-top-bar-bg-new {
  background-color: #e8eff2;
  width: 100%;
  height: 40px;
  z-index: 2;
}

.purple-top-bar-bg-bigger {
  height: 140px !important;
}

.admin-section {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border: 2px solid blue;
  margin: 10px;
  padding: 10px;
}

@media only screen and (max-width: 1000px) {
  .children-banner-new {
    position: absolute;
    top: 95% !important;
    left: 10%;
    width: 75%;
  }

  .white-footer {
    top: 125%;
  }
}

@media only screen and (max-width: 600px) {
  .kids-playing {
    position: absolute;
    top: 530px;
    left: 0px;
    width: 900px;
  }

  .main-content-area-new {
    top: 250px;
    margin-top: 35px;
    margin-left: 10px;
    margin-right: 10px;
    padding-left: 25px;
  }

  .white-footer {
    top: 105%;
    left: 0px;
    height: 80px;
  }
}
</style>
